import React, { useState } from "react";
import { showConfirm, showSuccess, showError } from "component/utils/SweetAlert";
import DataTable from "react-data-table-component";
import DatatableStyles, { scrollableTableContainer } from "component/utils/DatatableStyles";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import { formatRupiah } from "component/utils/formatRupiah";

const paginationOptions = {
  rowsPerPageText: "Show Per Page:",
  rangeSeparatorText: "dari",
};

const LapKasRekDatatables = ({ data, onShow }) => {
  const [search, setSearch] = useState("");
  const [date, setDate] = useState("");

  const formattedData = data.map((item, index) => ({
    id: index + 1,
    ...item,
  }));

  const filteredData = formattedData.filter((item) =>
    [
      item?.keterangan,
      item?.date_voucher,
    ].some((field) =>
      field?.toString().toLowerCase().includes(search.toLowerCase())
    )
  );

  const columns = [
    {
      name: "No",
      selector: (row) => row.id,
      minWidth: "70px",
      maxWidth: "100px",
      style: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      sortable: true,
    },
    {
      name: "Tanggal",
      selector: (row) => row.date_voucher,
      sortable: true,
      minWidth: "100px",
      style: { display: "flex", justifyContent: "center", alignItems: "center" },
    },
    {
      name: "Keterangan",
      selector: (row) => row.keterangan,
      sortable: true,
      minWidth: "450px",
      style: { display: "flex", justifyContent: "left", alignItems: "center" },
    },
    {
      name: "Debit",
      selector: (row) => formatRupiah(row.debit),
      sortable: true,
      minWidth: "120px",
      style: { display: "flex", justifyContent: "riht", alignItems: "center" },
    },
    {
      name: "Credit",
      selector: (row) => formatRupiah(row.credit),
      sortable: true,
      minWidth: "120px",
      style: { display: "flex", justifyContent: "right", alignItems: "center" },
    },
    {
      name: "Saldo",
      selector: (row) => formatRupiah(row.saldo),
      sortable: true,
      minWidth: "150px",
      style: { display: "flex", justifyContent: "right", alignItems: "center" },
    }
  ];

  return (
    <div className="row">
      <div className="col-lg-12 mb-4">
        <form onSubmit={(e) => {
          e.preventDefault();
          if (!date) {
            showError("Tanggal harus dipilih!");
            return;
          }
          onShow(date);
        }}>
          <div className="row mb-2 align-items-center">
              <label className="col-sm-2 form-label">Tanggal</label>
              <div className="col-sm-3">
                  <div className="input-group">
                      <span className="input-group-text">
                          <i className="bx bx-calendar"></i>
                      </span>
                      <Flatpickr
                          className="form-control form-control-sm "
                          value={date}
                          options={{
                          dateFormat: "Y-m-d",
                          }}
                          onChange={([selectedDate]) => {
                            setDate(selectedDate);
                          }}
                      />
                  </div>
              </div>
              <div className="col-sm-3">
                <button type="submit" className="btn btn-secondary">
                  <i className="fa fa-eye"></i>
                </button>
              </div>
          </div>
        </form>
      </div>
      <div className="col-lg-12 mb-4">
        <div className="d-flex justify-content-start align-items-center mb-2">
          <input
            type="text"
            placeholder="Search..."
            className="form-control w-100"
            style={{ maxWidth: "200px" }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div style={scrollableTableContainer}>
            <DataTable
              columns={columns}
              data={filteredData}
              pagination
              highlightOnHover
              customStyles={DatatableStyles}
              paginationPerPage={5}
              paginationRowsPerPageOptions={[5, 10, 25]}
              paginationComponentOptions={paginationOptions}
              responsive={false}
            />
        </div>
      </div>
    </div>
  );
};

export default LapKasRekDatatables;
